import { Action } from '@ngrx/store';
import { Order, Product, OrderLine } from '@vestiaire/api-sdk-angular';

export enum CartActionTypes {
  LoadCart = '[Cart] Load cart',
  LoadCartSuccess = '[Cart] Cart successfully loaded',
  LoadCartFailure = '[Cart] Cart loading failed',
  AddToCart = '[Cart] Add item to cart',
  AddToCartSuccess = '[Cart] Item added to cart',
  AddToCartFailure = '[Cart] Cannot add item to cart',
  RemoveFromCart = '[Cart] Remove item from cart',
  RemoveFromCartSuccess = '[Cart] Item removed from cart',
  RemoveFromCartFailure = '[Cart] Failed to remove item from cart'
}

export class LoadCart implements Action {
  readonly type = CartActionTypes.LoadCart;
}

export class LoadCartSuccess implements Action {
  readonly type = CartActionTypes.LoadCartSuccess;
  constructor(public payload: { order: Order }) {}
}

export class LoadCartFailure implements Action {
  readonly type = CartActionTypes.LoadCartFailure;
  constructor(public payload: string) {}
}

export class AddToCart implements Action {
  readonly type = CartActionTypes.AddToCart;
  constructor(
    public payload: {
      product: Product;
      quantity?: number;
      openDialog?: boolean;
    }
  ) {}
}

export class AddToCartSuccess implements Action {
  readonly type = CartActionTypes.AddToCartSuccess;
  constructor(
    public payload: {
      product: Product;
      quantity: number;
      orderLine: OrderLine;
      openDialog?: boolean;
    }
  ) {}
}

export class AddToCartFailure implements Action {
  readonly type = CartActionTypes.AddToCartFailure;
  constructor(public payload: { status?: number; detail?: string; objects?: any }) {}
}

export class RemoveFromCart implements Action {
  readonly type = CartActionTypes.RemoveFromCart;
  constructor(public payload: OrderLine) {}
}

export class RemoveFromCartSuccess implements Action {
  readonly type = CartActionTypes.RemoveFromCartSuccess;
  constructor(public payload: OrderLine) {}
}

export class RemoveFromCartFailure implements Action {
  readonly type = CartActionTypes.RemoveFromCartFailure;
}

export type CartActionsUnion =
  | LoadCart
  | LoadCartSuccess
  | LoadCartFailure
  | AddToCart
  | AddToCartSuccess
  | AddToCartFailure
  | RemoveFromCart
  | RemoveFromCartSuccess
  | RemoveFromCartFailure;
